module.exports = __webpack_public_path__ + "img/gg1.7f7199cb.png";